import { LicenseType, PersonPaginationSort } from '../gql/graphql';
import { getPaginatedNodes, toPagination } from './utils';

import { graphql } from '../gql';
import { useMemo } from 'react';
import { useQuery } from '@apollo/client';

export const GET_BROKER_LICENSES = graphql(`
  query getBrokerLicenses(
    $filters: PersonFilterInput
    $pagination: PaginationRequest
    $sort: PersonPaginationSort
    $licenseFilter: LicenseFilterInput
  ) {
    persons(filters: $filters, pagination: $pagination, sort: $sort) {
      pageInfo {
        totalResults
        hasNextPage
        hasPreviousPage
        pageNumber
        pageSize
      }
      edges {
        cursor
        node {
          uuid
          createdAt
          firstName
          lastName
          agent
          npn
          title
          source
          licenses(filters: $licenseFilter) {
            edges {
              cursor
              node {
                uuid
                licenseNumber
                expirationDate
                perpetual
                licenseType
                licenseHolder {
                  uuid
                  firstName
                  lastName
                }
                source
                forState
                region {
                  name
                  iso2Code
                  uuid
                }
              }
            }
          }
        }
      }
    }
  }
`);
export function useGetBrokerLicense({
  pageNumber = 0,
  pageSize = 15,
  uuid,
  sort,
  regionUuid,
  licenseType,
  enabled,
}: {
  pageNumber?: number;
  pageSize?: number;
  uuid?: string | null;
  sort?: PersonPaginationSort;
  regionUuid?: string;
  licenseType?: LicenseType;
  enabled?: boolean;
}) {
  const { loading, error, data } = useQuery(GET_BROKER_LICENSES, {
    variables: {
      pagination: toPagination(pageNumber, pageSize),
      sort,
      filters: {
        uuid: uuid,
      },
      licenseFilter: {
        regionUuid: regionUuid,
        licenseType: licenseType,
      },
    },
    skip: !enabled,
    fetchPolicy: 'no-cache',
  });

  const brokerLicenses = useMemo(() => {
    if (!data || !data.persons || !data.persons.edges) return [];
    const licenseList: {
      label: string | null | undefined;
      value: string | null | undefined;
      expirationDate: string | null | undefined;
      perpetual: boolean | null | undefined;
    }[] = [];

    getPaginatedNodes(data.persons).forEach((edge) => {
      const licenses = getPaginatedNodes(edge.licenses);

      licenses.forEach((license) => {
        licenseList.push({
          value: license.uuid,
          label: license.licenseNumber,
          expirationDate: license.expirationDate,
          perpetual: license.perpetual,
        });
      });
    });
    return licenseList;
  }, [data]);

  return {
    error,
    loading,
    data,
    brokerLicenses,
  };
}
